
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gfwv3_5sril_181",
  "horizontal": "awsui_horizontal_gfwv3_5sril_185",
  "vertical": "awsui_vertical_gfwv3_5sril_190",
  "list": "awsui_list_gfwv3_5sril_194",
  "list-item": "awsui_list-item_gfwv3_5sril_214",
  "toggle-container-inline": "awsui_toggle-container-inline_gfwv3_5sril_221",
  "toggle": "awsui_toggle_gfwv3_5sril_221",
  "description": "awsui_description_gfwv3_5sril_316",
  "separator": "awsui_separator_gfwv3_5sril_320"
};
  